// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"52":"18c01c50","267":"1125063b","271":"6f5e74c2","293":"f2813d6f","315":"192755df","454":"93adb17c","483":"b685db03","591":"6b8b09d0","646":"7dfb761d","652":"22f3e32d","676":"11eda173","690":"340f3e99","835":"ca4b4d4c","838":"c87ebfb9"}[chunkId] + ".js";
};